<template>

  <div class="details_block" v-loading="loading">
    <div>
      <h3 class="details_title">
        修改手机号审核
      </h3>
      <Divider />
      <el-card>

        <div class="card_content">
          <p>
            <span class="span_title">姓名:</span> {{ rowData.userName }}
          </p>
          <p>
            <span class="span_title">工作单位:</span> {{ rowData.deptName }}
          </p>
          <p>
            <span class="span_title">单位及职务:</span> {{ rowData.unitPosition }}
          </p>
          <p>
            <span class="span_title">旧手机号:</span> {{ rowData.oldMobile }}
          </p>
          <p>
            <span class="span_title">新手机号:</span> {{ rowData.newMobile }}
          </p>
        </div>
      </el-card>

      <h3 class="details_title mt-h3">
        审核进度
      </h3>
      <Divider />
      <el-timeline v-if="activities && activities.length > 0">
        <el-timeline-item v-for="(activity, index) in activities.filter(e => e.auditSchedule != 8)" placement="top"
          :key="index" :icon="activity.icon" :type="activity.type" :color="activity.color" :size="activity.size"
          :timestamp="activity.auditUserName + '(' + activity.unitPosition + ')'">
          <el-card>
            <p>
              <span class="mr-10px">{{ activity.createDate }}</span>
              <span class="mr-10px">{{ activity.auditScheduleName }}</span>
              <span class="mr-10px" v-if="activity.auditContent && activity.auditSchedule == 1">
                驳回原因：{{ activity.auditContent }}
              </span>

              <span class="mr-10px">{{ activity.auditAttachment && activity.auditAttachment[0].name }}</span>
              <el-button type="text" @click="preViewHandle(activity.auditAttachment[0])"
                v-if="activity.auditAttachment">
                预览
              </el-button>
              <el-button v-if="activity.auditAttachment" type="text" @click="downloadFile(activity.auditAttachment[0])">
                下载
              </el-button>
            </p>
          </el-card>
        </el-timeline-item>

        <el-timeline-item placement="top" v-if="activities.filter(e => e.auditSchedule == 8).length > 0">
          <el-card>
            <p v-for="(activity, index) in activities.filter(e => e.auditSchedule == 8)" :key="index">
              <span class="mr-10px">{{ activity.auditUserName }} ({{ activity.unitPosition }} )</span>
              <span class="mr-10px">{{ activity.auditScheduleName }}</span>
            </p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <div v-else class="text-center">暂无审核详情</div>

      <div class="button-wrap">
        <el-button @click="goBack">返回</el-button>

        <el-button v-if="rowData.myAuditStatus == 8 && closeDiaTrue != 1" @click="auditHandle" type="primary">
          审核
        </el-button>
      </div>
    </div>

    <AuditDialog ref="AuditDialog" :auditInfo="auditInfo" @closeDia="closeDia" />
    <pAuditDialog ref="PAuditDialog" :auditInfo="pAuditInfo" @closeDia="closeDia" />
    <OtherAuditDialog ref="PAuditDialog" :auditInfo="otherAuditInfo" @closeDia="closeDia" />
    <!-- 图片预览 -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="bigImgList" />
    <Auditor />
  </div>
</template>

<script>
import { auditFindAuditInfo, auditFindAuditStep } from "@/api/moveAudit";
import { downloadByUrl } from "@/utils/common.js";
import Divider from '@/components/divider/index'
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import AuditDialog from "./auditDialog.vue";
import Auditor from "./auditor";
import pAuditDialog from "./pAuditDialog.vue";
import OtherAuditDialog from "./otherAuditDialog.vue";

export default {
  components: {
    Divider,
    AuditDialog,
    Auditor,
    pAuditDialog,
    OtherAuditDialog,
    ElImageViewer
  },
  data() {
    return {
      activities: [],

      loading: false,
      // id: '',
      auditInfo: {
        showDia: false,
      },
      pAuditInfo: {
        showDia: false,
      },
      otherAuditInfo: {
        showDia: false,
      },


      rowData: {},
      showViewer: false,
      bigImgList: [],
      closeDiaTrue: '',

    };
  },
  props: {

  },
  methods: {
    closeViewer() {
      this.showViewer = false;
    },
    isImageType(name) {
      if (name) {
        const urlIndex = name.lastIndexOf(".");
        let ext = name.substr(urlIndex + 1);
        let flag =
          ["png", "jpg", "jpeg", "gif", "svg"].indexOf(ext.toLowerCase()) !==
          -1;
        return flag;
      }
      return false;
    },
    preViewHandle(item) {
      const { name, url } = item;

      if (!this.isImageType(name)) {
        window.open(url)
        return;
      }
      this.showViewer = true;
      this.bigImgList = [url];
    },
    downloadFile(val) {

      downloadByUrl(val.name, val.url);
    },
    closeDia(val, flag) {

      this.closeDiaTrue = flag
      this.auditInfo.showDia = false;
      this.pAuditInfo.showDia = false;
      this.otherAuditInfo.showDia = false;
      this.getAuditHistoryList();
      // if (flag) {
      //   this.$refs["pagination"].search(this.searchParams);
      // }
    },
    // audit(val) {
    //   // auditlist(val.uuid).then((res) => {
    //   //   if (res.code === 0) {
    //   //     this.auditInfo.row = res.data[res.data.length - 1];
    //   //     this.auditInfo.deptId = val.deptId;
    //   //     this.auditInfo.showDia = true;
    //   //   }
    //   // });
    //   this.auditInfo = {
    //     uuids: val.uuid,
    //     deptId: val.deptId,
    //     isBatch: false,
    //     showDia: true,
    //   }
    // },
    auditHandle(val) {

      auditFindAuditStep({
        userAuditUuid: this.rowData.userAuditUuid
      }).then(({ code, data }) => {
        if (code == 0) {

          if (data.step == 2) {
            this.auditInfo = {
              title: '审核',
              showDia: true,
            }
          }

          if (data.step == 3) {
            this.pAuditInfo = {
              title: '审核',
              showDia: true,
              prevStepUserName: data.prevStepUserName
            }
          }

          if (data.step == 1) {
            this.otherAuditInfo = {
              title: '审核',
              showDia: true,
            }
          }
        }
      })




    },
    goBack() {
      this.$router.push({
        path: '/phoneAudit'
      })
    },
    // 获取审核列表
    getAuditHistoryList() {
      this.loading = true
      auditFindAuditInfo({
        userAuditUuid: this.rowData.userAuditUuid
      }).then(res => {
        this.loading = false;
        if (res.code === 0) {
          let dataArray = res.data
          if (dataArray != null && dataArray.length > 0) {
            for (let i = 0; i < dataArray.length; i++) {
              if (
                i !== dataArray.length - 1 ||
                (i === dataArray.length - 1 &&
                  dataArray[i].auditSchedule != null)
              ) {
                dataArray[i].icon = "el-icon-success";
                dataArray[i].color = "#3A85FF";
              }
              dataArray[i].size = "large";
              dataArray[i].auditAttachment && (dataArray[i].auditAttachment = JSON.parse(dataArray[i].auditAttachment))
            }
            this.activities = dataArray;

          }
        }
      }).catch(_ => {
        this.loading = false;

      });
    },
    // 关闭
    // close() {
    //   this.activities = [];
    //   this.$emit('close')
    // }
  },
  created() {
    let v = this.$route.query?.row || {}
    this.rowData = JSON.parse(v)
    if (this.rowData.userAuditUuid) {
      this.getAuditHistoryList();
    }
  },
  beforeDestroy() {
    // Bus.$off("details");
  }
};
</script>
<style lang="scss" scoped>
.details_block {
  margin: 10px;
  padding: 10px;
}

.button-wrap {
  text-align: center;
  margin-top: 50px;
}

.card_content {
  font-size: 14px;
}

.details_title {
  position: relative;
  margin-left: 20px;

}

.mr-10px {
  margin-right: 10px;
}

.details_title::before {
  content: "";
  /* 必须要有content属性 */
  position: absolute;

  bottom: 0;

  left: -10px;

  width: 2px;

  height: 100%;

  background-color: #3a85ff;
}

.span_title {
  display: inline-block;
  width: 120px;
}

.mt-h3 {
  margin-top: 20px;
}
</style>